<form #form="ngForm" novalidate *ngIf="entity">
    <div class="mb-3">
        <sgt-accordion [settings]="{ isCollapsed: true }">
        <h6 header class="m-0">Cobrança</h6>

        <!-- Boletos -->
        <div class="row">
            <div class="form-group col-12 col-md">
                <label for="modoEnvioBoleto" class="col-form-label">Modo de envio dos boletos</label>
                <sgt-cliente-modo-envio-boleto-select
                    [ngModel]="entity.modoEnvioBoleto"
                    (ngModelChange)="onChangeModoEnvioBoleto($event)"
                    #modoEnvioBoleto="ngModel"
                    #modoEnvioBoletoSelect
                    name="modoEnvioBoleto"
                    id="modoEnvioBoleto"
                    [required]="config?.isModoEnvioBoletoRequired"
                    [disabled]="!canEdit">
                </sgt-cliente-modo-envio-boleto-select>
                <p class="form-text text-muted">Como o cliente deseja receber os boletos?</p>
                <sgt-form-control-error
                    *ngIf="modoEnvioBoleto.errors && modoEnvioBoleto.errors.required && modoEnvioBoleto.dirty"
                    msgError="O modo de envio dos boletos é obrigatório">
                </sgt-form-control-error>
            </div>
            <div class="form-group col-12 col-md" *ngIf="config?.isShowEmailBoleto">
                <label for="emailBoleto" class="col-form-label">E-mail Boleto</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <a href="mailto:{{entity.emailBoleto}}" class="btn btn-light" tabindex="-1">
                            <i class="far fa-envelope" aria-hidden="true"></i>
                        </a>
                    </div>
                    <input type="email" class="form-control" [(ngModel)]="entity.emailBoleto" name="emailBoleto" id="emailBoleto"
                        #emailBoleto="ngModel" #emailBoletoInput maxlength="255" required="required" [disabled]="!canEdit" [readonly]="!canEdit" sgtLowercase>
                </div>
                <p class="form-text text-muted">E-mail para qual devem ser enviados os boletos</p>
                <sgt-form-control-error
                    *ngIf="emailBoleto.errors && emailBoleto.errors.required && emailBoleto.dirty"
                    msgError="O e-mail para envio dos boletos é obrigatório">
                </sgt-form-control-error>
                <sgt-form-control-error
                    *ngIf="emailBoleto.errors && emailBoleto.errors.maxlength"
                    msgError="O e-mail para envio dos boletos deve ter no máximo 255 caracteres">
                </sgt-form-control-error>
            </div>
        </div>

        <!-- PIX -->
        <div class="row">
            <div class="form-group col-12">
                <label class="col-form-label" for="pagamentoViaPIX">Pagamento via PIX?</label>
                <br/>
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" class="custom-control-input" name="pagamentoViaPIX" id="pagamentoViaPIX_Sim" [value]="true" [(ngModel)]="entity.pagamentoViaPIX"
                        #pagamentoViaPIXModel="ngModel" [required]="config?.isPagamentoViaPIXRequired" [attr.disabled]="canEdit == false || null" [attr.readonly]="canEdit == false || null">
                    <label class="custom-control-label" for="pagamentoViaPIX_Sim">Sim</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" class="custom-control-input" name="pagamentoViaPIX" id="pagamentoViaPIX_Nao" [value]="false" [(ngModel)]="entity.pagamentoViaPIX"
                        [required]="config?.isPagamentoViaPIXRequired" [attr.disabled]="canEdit == false || null" [attr.readonly]="canEdit == false || null">
                    <label class="custom-control-label" for="pagamentoViaPIX_Nao">Não</label>
                </div>
                <sgt-form-control-error
                    *ngIf="pagamentoViaPIXModel.errors && pagamentoViaPIXModel.errors.required && pagamentoViaPIXModel.dirty"
                    msgError="É obrigatório selecionar se o cliente deseja pagar via PIX">
                </sgt-form-control-error>
                <p class="form-text text-muted">Selecione se o cliente deseja pagar via PIX</p>
            </div>
        </div>
        <ng-template [ngIf]="entity.pagamentoViaPIX">
            <div class="row">
                <div class="form-group col-12">
                    <label class="col-form-label" for="enviarPIXPorEmail">Enviar PIX por e-mail?</label>
                    <br/>
                    <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" class="custom-control-input" name="enviarPIXPorEmail" id="enviarPIXPorEmail_Sim" [value]="true" [ngModel]="entity.enviarPIXPorEmail" (ngModelChange)="onChangeEnviarPIXPorEmail($event)"
                            #enviarPIXPorEmailModel="ngModel" required="required" [attr.disabled]="canEdit == false || null" [attr.readonly]="canEdit == false || null">
                        <label class="custom-control-label" for="enviarPIXPorEmail_Sim">Sim</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" class="custom-control-input" name="enviarPIXPorEmail" id="enviarPIXPorEmail_Nao" [value]="false" [(ngModel)]="entity.enviarPIXPorEmail"
                            required="required" [attr.disabled]="canEdit == false || null" [attr.readonly]="canEdit == false || null">
                        <label class="custom-control-label" for="enviarPIXPorEmail_Nao">Não</label>
                    </div>
                    <sgt-form-control-error
                        *ngIf="enviarPIXPorEmailModel.errors && enviarPIXPorEmailModel.errors.required && enviarPIXPorEmailModel.dirty"
                        msgError="É obrigatório selecionar se o cliente deseja receber o link de pagamento do PIX por e-mail">
                    </sgt-form-control-error>
                    <p class="form-text text-muted">Selecione se o cliente deseja receber os links de pagamentos via PIX por e-mail</p>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12 col-md" *ngIf="entity.enviarPIXPorEmail">
                    <label for="emailPIX" class="col-form-label">E-mail PIX</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <a href="mailto:{{entity.emailPIX}}" class="btn btn-light" tabindex="-1">
                                <i class="far fa-envelope" aria-hidden="true"></i>
                            </a>
                        </div>
                        <input type="email" class="form-control" [(ngModel)]="entity.emailPIX" name="emailPIX" id="emailPIX"
                            #emailPIX="ngModel" #emailPIXInput maxlength="255" required="required" [disabled]="!canEdit" [readonly]="!canEdit" sgtLowercase>
                    </div>
                    <p class="form-text text-muted">E-mail para qual devem ser enviados os links de pagamentos via PIX</p>
                    <sgt-form-control-error
                        *ngIf="emailPIX.errors && emailPIX.errors.required && emailPIX.dirty"
                        msgError="O e-mail para envio dos links de pagamentos via PIX é obrigatório">
                    </sgt-form-control-error>
                    <sgt-form-control-error
                        *ngIf="emailPIX.errors && emailPIX.errors.maxlength"
                        msgError="O e-mail para envio dos links de pagamentos via PIX deve ter no máximo 255 caracteres">
                    </sgt-form-control-error>
                </div>
            </div>
        </ng-template>
        </sgt-accordion>
    </div>

    <div class="mb-3">
        <sgt-accordion [settings]="{ isCollapsed: true }">
        <h6 header class="m-0">Condições de Pagamento</h6>

        <!-- Modo de Pagamento Manual -->
        <ng-template [ngIf]="config?.isModoPagamentoManual">
            <div class="row">
                <div class="col-12">
                    <sgt-cliente-prazo-pagamento
                        [canEdit]="canEdit"
                        [canEditTipoPagamento]="config?.canEditTipoPagamento"
                        [entity]="entity"
                        #clientePrazoPagamentoCadastro>
                    </sgt-cliente-prazo-pagamento>
                </div>
            </div>
        </ng-template>

        <!-- Modo de Condição de Pagamento -->
        <ng-template [ngIf]="config?.isModoPagamentoCondicaoPagamento">
            <div class="row">
                <div class="form-group col-12 col-md">
                    <label class="col-form-label" for="condicaoPagamento">Selecione a Condição de Pagamento</label>
                    <sgt-novo-condicao-pagamento-select
                        [(ngModel)]="entity.idCondicaoPagamento"
                        (condicaoPagamentoChange)="onChangeCondicaoPagamento($event)"
                        name="condicaoPagamento"
                        id="condicaoPagamento"
                        [situacoes]="situacoesCondicaoPagamento"
                        [idCondicaoPagamentoPadrao]="entity?.idCondicaoPagamento ?? null"
                        [disabled]="!canEdit">
                    </sgt-novo-condicao-pagamento-select>
                </div>
                <div class="form-group col-12 col-md">
                    <label class="col-form-label" for="formaPagamento">Forma de Pagamento</label>
                    <sgt-forma-pagamento-select
                        [(ngModel)]="entity.idFormaPagamento"
                        [(formaPagamento)]="entity.formaPagamento"
                        #formaPagamentoSelect
                        name="formaPagamento"
                        id="formaPagamento"
                        [somenteAtivas]="true"
                        [disabled]="!canEdit">
                    </sgt-forma-pagamento-select>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12 col-md-6">
                    <label class="col-form-label">Prazos médios de pagamento (dias)</label>
                    <sgt-tokenfield-input
                        class="prazos-medios-tokenfield"
                        mode="number"
                        [tokens]="prazosMediosTokens"
                        [settings]="prazosMediosSettings"
                        (tokensChange)="onPrazosMediosChange($event)">
                    </sgt-tokenfield-input>
                </div>
            </div>
        </ng-template>

        <div class="row" *ngIf="configCliente?.exibirPreferenciasVencimentos">
            <div class="col-12">
                <label class="col-form-label">Preferências de Pagamentos</label>
                <br/>
                <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.preferenciaVencimentoSegunda" name="preferenciaVencimentoSegunda" id="preferenciaVencimentoSegunda"
                        [disabled]="!canEdit" [readonly]="!canEdit">
                    <label class="custom-control-label" for="preferenciaVencimentoSegunda">Segunda-Feira</label>
                </div>
                <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.preferenciaVencimentoTerca" name="preferenciaVencimentoTerca" id="preferenciaVencimentoTerca"
                        [disabled]="!canEdit" [readonly]="!canEdit">
                    <label class="custom-control-label" for="preferenciaVencimentoTerca">Terça-Feira</label>
                </div>
                <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.preferenciaVencimentoQuarta" name="preferenciaVencimentoQuarta" id="preferenciaVencimentoQuarta"
                        [disabled]="!canEdit" [readonly]="!canEdit">
                    <label class="custom-control-label" for="preferenciaVencimentoQuarta">Quarta-Feira</label>
                </div>
                <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.preferenciaVencimentoQuinta" name="preferenciaVencimentoQuinta" id="preferenciaVencimentoQuinta"
                        [disabled]="!canEdit" [readonly]="!canEdit">
                    <label class="custom-control-label" for="preferenciaVencimentoQuinta">Quinta-Feira</label>
                </div>
                <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.preferenciaVencimentoSexta" name="preferenciaVencimentoSexta" id="preferenciaVencimentoSexta"
                        [disabled]="!canEdit" [readonly]="!canEdit">
                    <label class="custom-control-label" for="preferenciaVencimentoSexta">Sexta-Feira</label>
                </div>
                <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.preferenciaVencimentoSabado" name="preferenciaVencimentoSabado" id="preferenciaVencimentoSabado"
                        [disabled]="!canEdit" [readonly]="!canEdit">
                    <label class="custom-control-label" for="preferenciaVencimentoSabado">Sábado</label>
                </div>
                <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.preferenciaVencimentoDomingo" name="preferenciaVencimentoDomingo" id="preferenciaVencimentoDomingo"
                        [disabled]="!canEdit" [readonly]="!canEdit">
                    <label class="custom-control-label" for="preferenciaVencimentoDomingo">Domingo</label>
                </div>
                <p class="form-text text-muted">Dias preferênciais de pagamentos do cliente</p>
            </div>
        </div>
        </sgt-accordion>
    </div>

    <div class="mb-3">
        <sgt-accordion [settings]="{ isCollapsed: true }">
        <h6 header class="m-0">Limite de Crédito</h6>

        <div class="row">
            <div class="form-group col-12 col-md">
                <label for="limiteCredito" class="col-form-label">Limite de Crédito</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            R$
                        </span>
                    </div>
                    <input type="text" class="form-control text-right" [value]="entity.limiteCredito | currencyFormat: 1:2:2" name="limiteCredito"
                        id="limiteCredito" disabled="disabled" readonly="readonly">
                </div>
                <p class="form-text text-muted">Limite de crédito do cliente</p>
            </div>
            <div class="form-group col-12 col-md">
                <label for="limiteCreditoDisponivel" class="col-form-label">Limite de Crédito Disponível</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            R$
                        </span>
                    </div>
                    <input type="text" class="form-control text-right" [value]="entity.limiteCreditoDisponivel | currencyFormat: 1:2:2" name="limiteCreditoDisponivel"
                        id="limiteCreditoDisponivel" disabled="disabled" readonly="readonly">
                </div>
                <p class="form-text text-muted">Limite de crédito ainda disponível para o cliente</p>
            </div>
        </div>
        </sgt-accordion>
    </div>
</form>
